


export default {
  styleOverrides: {
    root: {    
      '& .MuiInputBase-root': {
        borderRadius: 8,
        '&.MuiOutlinedInput-root': {
          '&:before': {
            borderBottom: 0,
          },
        },
        '&.MuiFilledInput-root': {
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        },         
      },    
    },    
  },    
};